<template>
  <div :class="`main-box color-${color}`">
    <div 
      class="item-box"
      :class="viewType == 'table' ? 'active' : ''"
      @click="viewType = 'table'"
    >{{ $t('table') }}</div>
    <div 
      class="item-box"
      :class="viewType == 'plan' ? 'active' : ''"
      @click="viewType = 'plan'"
    >{{ $t('area.market_plan') }}</div>
  </div>
</template>
<script>
export default {
  props: {
    value: String,
    color: String
  },
  computed: {
    viewType: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main-box {
  display: flex;
  align-items: center;
  border: 1px solid var(--v-success-base);
  border-radius: 5px;
  .item-box {
    cursor: pointer;
    padding: 8px 10px;
    color: var(--v-success-base);
    background-color: rgba(41, 199, 110, .1);
    transition: all 200ms;
    &.active {
      background-color: var(--v-success-base);
      color: white;
    }
  }
  &.color-info {
    border: 1px solid var(--v-info-base);
    .item-box {
      cursor: pointer;
      padding: 8px 10px;
      color: var(--v-info-base);
      background-color: rgba(0, 156, 229, .1);
      transition: all 200ms;
      &.active {
        background-color: var(--v-info-base);
        color: white;
      }
    }
  }
}
</style>